import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-menu-item',
  templateUrl: './mobile-menu-item.component.html',
  styleUrls: ['./mobile-menu-item.component.scss'],
})
export class MobileMenuItemComponent {
  @Input() linkText: string;
  @Input() link: string;
  @Output() onClick = new EventEmitter<null>();

  onItemClick(): void {
    this.onClick.emit();
  }
}
